<template>
  <async-btn
    v-if="show"
    :task="task"
    icon="fa fa-share"
    label="Send request"
    color="primary"
    v-bind="$attrs"
    rounded
    @click="createRequest"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { AuthType } from '@/type';
import { Account, ReconnectRequest } from '@/social/types';
import notify from '@/components/notify';
import { createRequest } from '.';

interface Data {
  task: Promise<ReconnectRequest>|null
}

export default defineComponent({
  emits: ['created'],
  components: { AsyncBtn },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    show(): boolean {
      const { auth } = this.account;
      return (!auth || auth.type === AuthType.LOGIN);
    },
  },
  methods: {
    async createRequest() {
      this.task = createRequest(this.account.id);
      const request = await this.task;
      this.$emit('created', request);
      notify(`${this.account.socialSite.name} posts have been requested.`);
    },
  },
});
</script>
